import React from "react";
import useStyleNotFound from "../styles/useStyleNotFound";

import { Container } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { Button } from "@material-ui/core";

const NotFound = (props) => {
  const classes = useStyleNotFound();
  const { history } = props; //Importo history dal props

  return (
    <Container style={{ height: "84vh" }}>
      <div className={classes.notfound}></div>
      <div className={classes.centratore}>
        <Typography component="h2" className={classes.h2}>
          Oops... Pagina non trovata!
        </Typography>
        <br />
        <Button variant="outlined" onClick={() => history.push("/")}>
          Back
        </Button>
      </div>
    </Container>
  );
};

export default NotFound;
